import { render, staticRenderFns } from "./CustomerDashCoupons.vue?vue&type=template&id=32901fce&scoped=true"
import script from "./CustomerDashCoupons.vue?vue&type=script&lang=js"
export * from "./CustomerDashCoupons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32901fce",
  null
  
)

export default component.exports